module.exports = __webpack_public_path__ + "img/spell-check.c1db810a.svg";